import React, { Component } from "react";
import Images from "../Images";
import { Carousel } from "antd";
import { connect } from "react-redux";
import { JackpotLevel } from "../../../helpers/enums";
import Odometer from "react-odometerjs";
import { AppConfig } from "../../../helpers";
import SlotGame from "./SlotGame";

const jackpotSize = "medium";
export class SlotsHeading extends Component {
  render() {
    const {
      jackpotBalances,
      winningMessage,
      jackpotImage,
      row1Col2Games,
      history,
      row1Col2ImageType,
      slidesToShow
    } = this.props;
    return (
      <div className="slots-heading">
        <div className="jackpot-wrapper">
          <img src={jackpotImage} alt="jackpot" />
          <div className="jackpots-text">
            <div className={`odomemter-wrapper blue-${jackpotSize}`}>
              {winningMessage ? (
                <div className="jackpots-text-win">{winningMessage}</div>
              ) : (
                <>
                  <div className="currency">
                    {jackpotBalances && jackpotBalances[JackpotLevel.Web]
                      ? jackpotBalances[JackpotLevel.Web].currencySymbol
                      : "LD"}
                  </div>
                  <Odometer
                    value={
                      jackpotBalances && jackpotBalances[JackpotLevel.Web]
                        ? jackpotBalances[JackpotLevel.Web].jackpotAmount
                        : 0
                    }
                    format="(,ddd).dd"
                    theme="default"
                  />
                </>
              )}
            </div>

            {!winningMessage && (
              <div className={`odomemter-wrapper usd-blue-${jackpotSize}`}>
                <div className="currency">$</div>
                <Odometer
                  value={
                    jackpotBalances && jackpotBalances[JackpotLevel.Web]
                      ? jackpotBalances[JackpotLevel.Web].jackpotUsdValue
                      : 0
                  }
                  format="(,ddd).dd"
                  theme="default"
                />
              </div>
            )}
          </div>
        </div>
        <div className="courasel-wrapper">
          {row1Col2Games && (
            <Carousel
              slidesToShow={slidesToShow}
              effect="fade"
              dots={true}
              dotPosition={"bottom"}
              infinite={true}
              autoplay
            >
              {/* let url = AppConfig.icons;
      let src = `${url}${imageName}?id=${this.props.data.gameImageVersion}`; */}
              {row1Col2Games.map((game) => (
                <div>
                  <SlotGame
                    src={`${AppConfig.icons}${game.platformGameName}/${game.slotsGameImages.filter(game => game.imageTypeId ==row1Col2ImageType)[0] ? game.slotsGameImages.filter(game => game.imageTypeId ==row1Col2ImageType)[0].gameImage : game.platformGameName}.webp`}
                    history={history}
                    gameId={game.gameId}
                  />
                </div>
              ))}
            </Carousel>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    jackpotBalances: state.jackpot.jackpotBalances,
    winningMessage: state.jackpot.winningMessage,
    jackpotImage: state.general.configuration.jackpotImage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SlotsHeading);
